export default {

	getPlacePredictions(google, searchPhrase) {
		return new Promise((resolve, reject) => {

			let service = new google.maps.places.AutocompleteService;
			service.getPlacePredictions({
				input: searchPhrase,
				componentRestrictions: {
					country: 'za'
				}
			}, function(predictions, status) {
				if(status === 'OK') {
					resolve(predictions);
				}
				reject(status);
			});
		});
	},

	geocodeLatLng(google, request) {
		return new Promise((resolve, reject) => {
			let service = new google.maps.Geocoder();
			service.geocode(request, function(results, status) {
				if(status === 'OK') {
					resolve(results[0]);
				}
				reject(status);
			});
		});
	},
}
